'use strict';

import {observable, configure, action, observe, makeObservable} from "mobx";

configure({enforceActions: 'always'});

/**
 * Store for data for the Registration Tools
 */
class RegToolsStore {

    currentTab = window.sessionStorage.getItem("regtools-tab") ?? "reg";
    agreeToTOS = JSON.parse(window.localStorage.getItem("regtools-agreeToTOS")) ?? false; // Use local storage to persist across sessions
    regGeneralForm = JSON.parse(window.sessionStorage.getItem("regtools-regGeneralForm")) ?? {
        // Control the nextAction
        nextAction: "unset",
    };
    acknowledgeForm = JSON.parse(window.sessionStorage.getItem("regtools-acknowledgeForm")) ?? {
        // Whether to do any overriding at all.
        override: false,
        // Show all acknowledgements if true
        showAll: true,
        // Override the campus if provided
        campus: null,
    };
    optChargesForm = JSON.parse(window.sessionStorage.getItem("regtools-optChargesForm")) ?? {
        // Whether to do any overriding at all.
        override: false,
        // Yes/No fields.
        eligible_sw: "N",
        acad_year_gaip_sw: "N",
        enroll_requird_sw: "N",
        has_annual_ins_sw: "N",
        ins_update_sw: "N",
        ta_ra_sw: "N",
        // Dropdowns
        branch_code: "0",
        ins_status_char: "A",
        ins_tier: "0",
        process_code: "0",
        resident_code: "0",
        // Free form fields
        class_code: "",
        curr_ins_sel_code: "",
        curr_ins_sel_amt: "",
        exemption_code: "",
        ins_cancel_reason: "",
        insurance_sel: "",
    };

    constructor() {
        makeObservable(this, {
            currentTab: observable,
            agreeToTOS: observable,
            regGeneralForm: observable,
            acknowledgeForm: observable,
            optChargesForm: observable,
            setCurrentTab: action,
            setRegGeneralFormItem: action,
            setOptChargesFormItem: action,
            toggleAgreeToTOS: action,
            _setFormValue: action,
        });
    }

    /**
     * Set the current tab
     * @param {string} tab
     */
    setCurrentTab(tab) {
        this.currentTab = tab;
        window.sessionStorage.setItem("regtools-tab", tab);
    }

    toggleAgreeToTOS = () => {
        this.agreeToTOS = !this.agreeToTOS;
        // NOTE: using localStorage to persist across sessions
        window.localStorage.setItem("regtools-agreeToTOS", JSON.stringify(this.agreeToTOS));
    }

    /**
     * Set an item in the regGeneralForm. Key can also be a change event like from a form input.
     */
    setRegGeneralFormItem = (key, value) => {
        if (key.type === "change") {
            value = key.target.value
            key = key.target.name
        }
        this._setFormValue("regGeneralForm", key, value);
    }

    /**
     * Set an item in the acknowledgeForm. Key can also be a change event like from a form input.
     */
    setAcknowledgeFormItem = (key, value) => {
        if (key.type === "change") {
            value = key.target.value
            key = key.target.name
        }
        this._setFormValue("acknowledgeForm", key, value);
    }

    /**
     * Toggle a boolean in the acknowledgeForm. Key can also be a change event like from a form input.
     */
    toggleAcknowledgeFormItem = (key) => {
        if (key.type === "change") {
            key = key.target.name
        }
        this._setFormValue("acknowledgeForm", key, !this.acknowledgeForm[key]);
    }

    /**
     * Set an item in the optChargesForm. Key can also be a change event like from a form input.
     */
    setOptChargesFormItem = (key, value) => {
        if (key.type === "change") {
            value = key.target.value
            key = key.target.name
        }
        this._setFormValue("optChargesForm", key, value);
    }

    /**
     * Toggle a boolean in the optChargesForm. Key can also be a change event like from a form input.
     */
    toggleOptChargesFormItem = (key) => {
        if (key.type === "change") {
            key = key.target.name
        }
        this._setFormValue("optChargesForm", key, !this.optChargesForm[key]);
    }

    clearSessionStores = () => {
        window.sessionStorage.removeItem("regtools-tab");
        window.sessionStorage.removeItem("regtools-regGeneralForm");
        window.sessionStorage.removeItem("regtools-acknowledgeForm");
        window.sessionStorage.removeItem("regtools-optChargesForm");
    }

    _setFormValue(formName, key, value) {
        this[formName][key] = value;
        window.sessionStorage.setItem(`regtools-${formName}`, JSON.stringify(this[formName]));
    }
}

export default new RegToolsStore();
